import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApContentModule } from '@ap/content';
import { ApPersistenceModule } from '@ap/persistence';
import { ApSignComponent } from '@ap/sign';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApLoggingModule } from '@ap/logging';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';

import { NoAvailableTokensModalModule } from './no-available-tokens-modal/no-available-tokens-modal.module';
import { SignComponent } from './sign.component';

/**
 * @name SignModule
 * @ngdoc module
 */
@NgModule({
    imports: [
        ApSignComponent,
        ApContentModule,
        ApAnalyticsModule,
        ApLoggingModule,
        ApPersistenceModule,
        CommonModule,
        NoAvailableTokensModalModule,
        SessiebeheerModule
    ],
    exports: [SignComponent],
    declarations: [SignComponent]
})
export class SignModule {}
